// types of filter components
export enum FilterItemType {
  DATE = 'date',
  SELECT = 'select',
  FULLTEXT = 'fulltext',
}
// properties of one component
export interface FilterOption {
  data?: object[] | null;
  valueId?: string;
  valueKey?: string;
  className?: string;
  type: FilterItemType;
  title?: string;
  value?: any;
  // date component
  dateType?: 'Date' | 'Datetime';
  // fulltext
  setData?: React.Dispatch<React.SetStateAction<any | null>>;
  includedFields?: string[];
}
